export const DATABASE_COLLECTIONS = {
    USERS: 'users',
    PROJECTS: 'projects',
    SPLITS: 'splits'
}